// THIS FILE IS GENERATED, DO NOT EDIT!
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
};

export type Query = {
  __typename?: 'Query';
  bookCollection?: Maybe<BookCollections>;
  bookCollections?: Maybe<Array<Maybe<BookCollections>>>;
  bookCollectionsConnection?: Maybe<BookCollectionsConnection>;
  book?: Maybe<Books>;
  books?: Maybe<Array<Maybe<Books>>>;
  booksConnection?: Maybe<BooksConnection>;
  onlineChurchPoster?: Maybe<OnlineChurchPoster>;
  onlineChurch?: Maybe<OnlineChurch>;
  onlineChurches?: Maybe<Array<Maybe<OnlineChurch>>>;
  onlineChurchesConnection?: Maybe<OnlineChurchConnection>;
  propheticChannel?: Maybe<PropheticChannel>;
  quote?: Maybe<Quotes>;
  quotes?: Maybe<Array<Maybe<Quotes>>>;
  quotesConnection?: Maybe<QuotesConnection>;
  subscription?: Maybe<Subscription>;
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  subscriptionsConnection?: Maybe<SubscriptionConnection>;
  videoCollection?: Maybe<VideoCollections>;
  videoCollections?: Maybe<Array<Maybe<VideoCollections>>>;
  videoCollectionsConnection?: Maybe<VideoCollectionsConnection>;
  video?: Maybe<Videos>;
  videos?: Maybe<Array<Maybe<Videos>>>;
  videosConnection?: Maybe<VideosConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  analytics?: Maybe<Analytics>;
  paginatedBookCollection?: Maybe<PaginatedBookCollection>;
  nextOnlineChurch?: Maybe<OnlineChurch>;
  nextQuote?: Maybe<Quotes>;
  activeSubscription?: Maybe<SubscriptionPayload>;
  paginatedVideoCollection?: Maybe<PaginatedVideoCollection>;
  me?: Maybe<UsersPermissionsMe>;
  self?: Maybe<UsersPermissionsUser>;
};


export type QueryBookCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryBookCollectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBookCollectionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBookArgs = {
  id: Scalars['ID'];
};


export type QueryBooksArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBooksConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOnlineChurchArgs = {
  id: Scalars['ID'];
};


export type QueryOnlineChurchesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOnlineChurchesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID'];
};


export type QueryQuotesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryQuotesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubscriptionArgs = {
  id: Scalars['ID'];
};


export type QuerySubscriptionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySubscriptionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVideoCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryVideoCollectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVideoCollectionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVideoArgs = {
  id: Scalars['ID'];
};


export type QueryVideosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVideosConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPaginatedBookCollectionArgs = {
  id: Scalars['Int'];
  cursor?: Maybe<Scalars['ID']>;
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNextQuoteArgs = {
  id_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


export type QueryPaginatedVideoCollectionArgs = {
  id: Scalars['Int'];
  cursor?: Maybe<Scalars['ID']>;
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type BookCollections = {
  __typename?: 'BookCollections';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  books?: Maybe<Array<Maybe<Books>>>;
};


export type BookCollectionsBooksArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};



export type Books = {
  __typename?: 'Books';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  buyNowLink?: Maybe<Scalars['String']>;
  previewLink?: Maybe<Scalars['String']>;
  cover?: Maybe<UploadFile>;
  bookCollections?: Maybe<Array<Maybe<BookCollections>>>;
};


export type BooksBookCollectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Morph = Analytics | PaginatedBookCollection | PaginatedBooks | PageInfo | CheckoutSessionPayload | Price | PaymentMethod | SubscriptionPayload | PaginatedVideoCollection | PaginatedVideos | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | ChangePasswordPayload | BookCollections | BookCollectionsConnection | BookCollectionsAggregator | BookCollectionsGroupBy | BookCollectionsConnectionId | BookCollectionsConnectionCreated_At | BookCollectionsConnectionUpdated_At | BookCollectionsConnectionName | CreateBookCollectionPayload | UpdateBookCollectionPayload | DeleteBookCollectionPayload | Books | BooksConnection | BooksAggregator | BooksGroupBy | BooksConnectionId | BooksConnectionCreated_At | BooksConnectionUpdated_At | BooksConnectionTitle | BooksConnectionAuthor | BooksConnectionDescription | BooksConnectionBuyNowLink | BooksConnectionPreviewLink | BooksConnectionCover | CreateBookPayload | UpdateBookPayload | DeleteBookPayload | OnlineChurchPoster | UpdateOnlineChurchPosterPayload | DeleteOnlineChurchPosterPayload | OnlineChurch | OnlineChurchConnection | OnlineChurchAggregator | OnlineChurchGroupBy | OnlineChurchConnectionId | OnlineChurchConnectionCreated_At | OnlineChurchConnectionUpdated_At | OnlineChurchConnectionTitle | OnlineChurchConnectionDateTime | OnlineChurchConnectionLink | CreateOnlineChurchPayload | UpdateOnlineChurchPayload | DeleteOnlineChurchPayload | PropheticChannel | UpdatePropheticChannelPayload | DeletePropheticChannelPayload | Quotes | QuotesConnection | QuotesAggregator | QuotesGroupBy | QuotesConnectionId | QuotesConnectionCreated_At | QuotesConnectionUpdated_At | QuotesConnectionDescription | QuotesConnectionDate | CreateQuotePayload | UpdateQuotePayload | DeleteQuotePayload | Subscription | SubscriptionConnection | SubscriptionAggregator | SubscriptionGroupBy | SubscriptionConnectionId | SubscriptionConnectionCreated_At | SubscriptionConnectionUpdated_At | SubscriptionConnectionStripeId | SubscriptionConnectionCustomer | SubscriptionConnectionCurrentPeriodEnd | SubscriptionConnectionCurrentPeriodStart | SubscriptionConnectionName | SubscriptionConnectionPaymentMethod | CreateSubscriptionPayload | UpdateSubscriptionPayload | DeleteSubscriptionPayload | VideoCollections | VideoCollectionsConnection | VideoCollectionsAggregator | VideoCollectionsGroupBy | VideoCollectionsConnectionId | VideoCollectionsConnectionCreated_At | VideoCollectionsConnectionUpdated_At | VideoCollectionsConnectionName | CreateVideoCollectionPayload | UpdateVideoCollectionPayload | DeleteVideoCollectionPayload | Videos | VideosConnection | VideosAggregator | VideosGroupBy | VideosConnectionId | VideosConnectionCreated_At | VideosConnectionUpdated_At | VideosConnectionVideo | VideosConnectionTitle | CreateVideoPayload | UpdateVideoPayload | DeleteVideoPayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionPhoneNumber | UsersPermissionsUserConnectionProfilePicture | UsersPermissionsUserConnectionIsSubscribed | UsersPermissionsUserConnectionFirstName | UsersPermissionsUserConnectionLastName | UsersPermissionsUserConnectionStripeCustomerId | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentPaymentMethodPaymentMethod;

export type Analytics = {
  __typename?: 'Analytics';
  accessToken?: Maybe<Scalars['String']>;
  activeUsers?: Maybe<Scalars['Int']>;
  sessionsToday?: Maybe<Scalars['Int']>;
  usersNearMe?: Maybe<Scalars['Int']>;
};

export type PaginatedBookCollection = {
  __typename?: 'PaginatedBookCollection';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  books?: Maybe<PaginatedBooks>;
};

export type PaginatedBooks = {
  __typename?: 'PaginatedBooks';
  nodes?: Maybe<Array<Maybe<Books>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export type CheckoutSessionPayload = {
  __typename?: 'CheckoutSessionPayload';
  checkoutSessionId?: Maybe<Scalars['String']>;
};

export type Price = {
  __typename?: 'Price';
  amount?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export type SubscriptionPayload = {
  __typename?: 'SubscriptionPayload';
  id?: Maybe<Scalars['String']>;
  currentPeriodEnd?: Maybe<Scalars['Int']>;
  currentPeriodStart?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  paymentMethod?: Maybe<PaymentMethod>;
};

export type PaginatedVideoCollection = {
  __typename?: 'PaginatedVideoCollection';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  videos?: Maybe<PaginatedVideos>;
};

export type PaginatedVideos = {
  __typename?: 'PaginatedVideos';
  nodes?: Maybe<Array<Maybe<Videos>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Videos = {
  __typename?: 'Videos';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  video?: Maybe<UploadFile>;
  title?: Maybe<Scalars['String']>;
  videoCollections?: Maybe<Array<Maybe<VideoCollections>>>;
};


export type VideosVideoCollectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type VideoCollections = {
  __typename?: 'VideoCollections';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<Videos>>>;
};


export type VideoCollectionsVideosArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt: Scalars['String'];
  user: UsersPermissionsMe;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  jwt: Scalars['String'];
  user: UsersPermissionsUser;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<UploadFile>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type BookCollectionsConnection = {
  __typename?: 'BookCollectionsConnection';
  values?: Maybe<Array<Maybe<BookCollections>>>;
  groupBy?: Maybe<BookCollectionsGroupBy>;
  aggregate?: Maybe<BookCollectionsAggregator>;
};

export type BookCollectionsGroupBy = {
  __typename?: 'BookCollectionsGroupBy';
  id?: Maybe<Array<Maybe<BookCollectionsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BookCollectionsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BookCollectionsConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<BookCollectionsConnectionName>>>;
};

export type BookCollectionsConnectionId = {
  __typename?: 'BookCollectionsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BookCollectionsConnection>;
};

export type BookCollectionsConnectionCreated_At = {
  __typename?: 'BookCollectionsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookCollectionsConnection>;
};

export type BookCollectionsConnectionUpdated_At = {
  __typename?: 'BookCollectionsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BookCollectionsConnection>;
};

export type BookCollectionsConnectionName = {
  __typename?: 'BookCollectionsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BookCollectionsConnection>;
};

export type BookCollectionsAggregator = {
  __typename?: 'BookCollectionsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateBookCollectionPayload = {
  __typename?: 'createBookCollectionPayload';
  bookCollection?: Maybe<BookCollections>;
};

export type UpdateBookCollectionPayload = {
  __typename?: 'updateBookCollectionPayload';
  bookCollection?: Maybe<BookCollections>;
};

export type DeleteBookCollectionPayload = {
  __typename?: 'deleteBookCollectionPayload';
  bookCollection?: Maybe<BookCollections>;
};

export type BooksConnection = {
  __typename?: 'BooksConnection';
  values?: Maybe<Array<Maybe<Books>>>;
  groupBy?: Maybe<BooksGroupBy>;
  aggregate?: Maybe<BooksAggregator>;
};

export type BooksGroupBy = {
  __typename?: 'BooksGroupBy';
  id?: Maybe<Array<Maybe<BooksConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BooksConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BooksConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<BooksConnectionTitle>>>;
  author?: Maybe<Array<Maybe<BooksConnectionAuthor>>>;
  description?: Maybe<Array<Maybe<BooksConnectionDescription>>>;
  buyNowLink?: Maybe<Array<Maybe<BooksConnectionBuyNowLink>>>;
  previewLink?: Maybe<Array<Maybe<BooksConnectionPreviewLink>>>;
  cover?: Maybe<Array<Maybe<BooksConnectionCover>>>;
};

export type BooksConnectionId = {
  __typename?: 'BooksConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksConnectionCreated_At = {
  __typename?: 'BooksConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksConnectionUpdated_At = {
  __typename?: 'BooksConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksConnectionTitle = {
  __typename?: 'BooksConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksConnectionAuthor = {
  __typename?: 'BooksConnectionAuthor';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksConnectionDescription = {
  __typename?: 'BooksConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksConnectionBuyNowLink = {
  __typename?: 'BooksConnectionBuyNowLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksConnectionPreviewLink = {
  __typename?: 'BooksConnectionPreviewLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksConnectionCover = {
  __typename?: 'BooksConnectionCover';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BooksConnection>;
};

export type BooksAggregator = {
  __typename?: 'BooksAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateBookPayload = {
  __typename?: 'createBookPayload';
  book?: Maybe<Books>;
};

export type UpdateBookPayload = {
  __typename?: 'updateBookPayload';
  book?: Maybe<Books>;
};

export type DeleteBookPayload = {
  __typename?: 'deleteBookPayload';
  book?: Maybe<Books>;
};

export type OnlineChurchPoster = {
  __typename?: 'OnlineChurchPoster';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  poster?: Maybe<UploadFile>;
};

export type UpdateOnlineChurchPosterPayload = {
  __typename?: 'updateOnlineChurchPosterPayload';
  onlineChurchPoster?: Maybe<OnlineChurchPoster>;
};

export type DeleteOnlineChurchPosterPayload = {
  __typename?: 'deleteOnlineChurchPosterPayload';
  onlineChurchPoster?: Maybe<OnlineChurchPoster>;
};

export type OnlineChurch = {
  __typename?: 'OnlineChurch';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  poster?: Maybe<UploadFile>;
};

export type OnlineChurchConnection = {
  __typename?: 'OnlineChurchConnection';
  values?: Maybe<Array<Maybe<OnlineChurch>>>;
  groupBy?: Maybe<OnlineChurchGroupBy>;
  aggregate?: Maybe<OnlineChurchAggregator>;
};

export type OnlineChurchGroupBy = {
  __typename?: 'OnlineChurchGroupBy';
  id?: Maybe<Array<Maybe<OnlineChurchConnectionId>>>;
  created_at?: Maybe<Array<Maybe<OnlineChurchConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<OnlineChurchConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<OnlineChurchConnectionTitle>>>;
  dateTime?: Maybe<Array<Maybe<OnlineChurchConnectionDateTime>>>;
  link?: Maybe<Array<Maybe<OnlineChurchConnectionLink>>>;
};

export type OnlineChurchConnectionId = {
  __typename?: 'OnlineChurchConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OnlineChurchConnection>;
};

export type OnlineChurchConnectionCreated_At = {
  __typename?: 'OnlineChurchConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OnlineChurchConnection>;
};

export type OnlineChurchConnectionUpdated_At = {
  __typename?: 'OnlineChurchConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OnlineChurchConnection>;
};

export type OnlineChurchConnectionTitle = {
  __typename?: 'OnlineChurchConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OnlineChurchConnection>;
};

export type OnlineChurchConnectionDateTime = {
  __typename?: 'OnlineChurchConnectionDateTime';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OnlineChurchConnection>;
};

export type OnlineChurchConnectionLink = {
  __typename?: 'OnlineChurchConnectionLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OnlineChurchConnection>;
};

export type OnlineChurchAggregator = {
  __typename?: 'OnlineChurchAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateOnlineChurchPayload = {
  __typename?: 'createOnlineChurchPayload';
  onlineChurch?: Maybe<OnlineChurch>;
};

export type UpdateOnlineChurchPayload = {
  __typename?: 'updateOnlineChurchPayload';
  onlineChurch?: Maybe<OnlineChurch>;
};

export type DeleteOnlineChurchPayload = {
  __typename?: 'deleteOnlineChurchPayload';
  onlineChurch?: Maybe<OnlineChurch>;
};

export type PropheticChannel = {
  __typename?: 'PropheticChannel';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type UpdatePropheticChannelPayload = {
  __typename?: 'updatePropheticChannelPayload';
  propheticChannel?: Maybe<PropheticChannel>;
};

export type DeletePropheticChannelPayload = {
  __typename?: 'deletePropheticChannelPayload';
  propheticChannel?: Maybe<PropheticChannel>;
};

export type Quotes = {
  __typename?: 'Quotes';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
};


export type QuotesConnection = {
  __typename?: 'QuotesConnection';
  values?: Maybe<Array<Maybe<Quotes>>>;
  groupBy?: Maybe<QuotesGroupBy>;
  aggregate?: Maybe<QuotesAggregator>;
};

export type QuotesGroupBy = {
  __typename?: 'QuotesGroupBy';
  id?: Maybe<Array<Maybe<QuotesConnectionId>>>;
  created_at?: Maybe<Array<Maybe<QuotesConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<QuotesConnectionUpdated_At>>>;
  description?: Maybe<Array<Maybe<QuotesConnectionDescription>>>;
  date?: Maybe<Array<Maybe<QuotesConnectionDate>>>;
};

export type QuotesConnectionId = {
  __typename?: 'QuotesConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<QuotesConnection>;
};

export type QuotesConnectionCreated_At = {
  __typename?: 'QuotesConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuotesConnection>;
};

export type QuotesConnectionUpdated_At = {
  __typename?: 'QuotesConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<QuotesConnection>;
};

export type QuotesConnectionDescription = {
  __typename?: 'QuotesConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<QuotesConnection>;
};

export type QuotesConnectionDate = {
  __typename?: 'QuotesConnectionDate';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<QuotesConnection>;
};

export type QuotesAggregator = {
  __typename?: 'QuotesAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateQuotePayload = {
  __typename?: 'createQuotePayload';
  quote?: Maybe<Quotes>;
};

export type UpdateQuotePayload = {
  __typename?: 'updateQuotePayload';
  quote?: Maybe<Quotes>;
};

export type DeleteQuotePayload = {
  __typename?: 'deleteQuotePayload';
  quote?: Maybe<Quotes>;
};

export type Subscription = {
  __typename?: 'Subscription';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  stripeId?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  currentPeriodEnd?: Maybe<Scalars['Long']>;
  currentPeriodStart?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<ComponentPaymentMethodPaymentMethod>;
};


export type ComponentPaymentMethodPaymentMethod = {
  __typename?: 'ComponentPaymentMethodPaymentMethod';
  id: Scalars['ID'];
  brand?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export type SubscriptionConnection = {
  __typename?: 'SubscriptionConnection';
  values?: Maybe<Array<Maybe<Subscription>>>;
  groupBy?: Maybe<SubscriptionGroupBy>;
  aggregate?: Maybe<SubscriptionAggregator>;
};

export type SubscriptionGroupBy = {
  __typename?: 'SubscriptionGroupBy';
  id?: Maybe<Array<Maybe<SubscriptionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<SubscriptionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<SubscriptionConnectionUpdated_At>>>;
  stripeId?: Maybe<Array<Maybe<SubscriptionConnectionStripeId>>>;
  customer?: Maybe<Array<Maybe<SubscriptionConnectionCustomer>>>;
  currentPeriodEnd?: Maybe<Array<Maybe<SubscriptionConnectionCurrentPeriodEnd>>>;
  currentPeriodStart?: Maybe<Array<Maybe<SubscriptionConnectionCurrentPeriodStart>>>;
  name?: Maybe<Array<Maybe<SubscriptionConnectionName>>>;
  paymentMethod?: Maybe<Array<Maybe<SubscriptionConnectionPaymentMethod>>>;
};

export type SubscriptionConnectionId = {
  __typename?: 'SubscriptionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionCreated_At = {
  __typename?: 'SubscriptionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionUpdated_At = {
  __typename?: 'SubscriptionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionStripeId = {
  __typename?: 'SubscriptionConnectionStripeId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionCustomer = {
  __typename?: 'SubscriptionConnectionCustomer';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionCurrentPeriodEnd = {
  __typename?: 'SubscriptionConnectionCurrentPeriodEnd';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionCurrentPeriodStart = {
  __typename?: 'SubscriptionConnectionCurrentPeriodStart';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionName = {
  __typename?: 'SubscriptionConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionConnectionPaymentMethod = {
  __typename?: 'SubscriptionConnectionPaymentMethod';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<SubscriptionConnection>;
};

export type SubscriptionAggregator = {
  __typename?: 'SubscriptionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateSubscriptionPayload = {
  __typename?: 'createSubscriptionPayload';
  subscription?: Maybe<Subscription>;
};

export type UpdateSubscriptionPayload = {
  __typename?: 'updateSubscriptionPayload';
  subscription?: Maybe<Subscription>;
};

export type DeleteSubscriptionPayload = {
  __typename?: 'deleteSubscriptionPayload';
  subscription?: Maybe<Subscription>;
};

export type VideoCollectionsConnection = {
  __typename?: 'VideoCollectionsConnection';
  values?: Maybe<Array<Maybe<VideoCollections>>>;
  groupBy?: Maybe<VideoCollectionsGroupBy>;
  aggregate?: Maybe<VideoCollectionsAggregator>;
};

export type VideoCollectionsGroupBy = {
  __typename?: 'VideoCollectionsGroupBy';
  id?: Maybe<Array<Maybe<VideoCollectionsConnectionId>>>;
  created_at?: Maybe<Array<Maybe<VideoCollectionsConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<VideoCollectionsConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<VideoCollectionsConnectionName>>>;
};

export type VideoCollectionsConnectionId = {
  __typename?: 'VideoCollectionsConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VideoCollectionsConnection>;
};

export type VideoCollectionsConnectionCreated_At = {
  __typename?: 'VideoCollectionsConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VideoCollectionsConnection>;
};

export type VideoCollectionsConnectionUpdated_At = {
  __typename?: 'VideoCollectionsConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VideoCollectionsConnection>;
};

export type VideoCollectionsConnectionName = {
  __typename?: 'VideoCollectionsConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VideoCollectionsConnection>;
};

export type VideoCollectionsAggregator = {
  __typename?: 'VideoCollectionsAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateVideoCollectionPayload = {
  __typename?: 'createVideoCollectionPayload';
  videoCollection?: Maybe<VideoCollections>;
};

export type UpdateVideoCollectionPayload = {
  __typename?: 'updateVideoCollectionPayload';
  videoCollection?: Maybe<VideoCollections>;
};

export type DeleteVideoCollectionPayload = {
  __typename?: 'deleteVideoCollectionPayload';
  videoCollection?: Maybe<VideoCollections>;
};

export type VideosConnection = {
  __typename?: 'VideosConnection';
  values?: Maybe<Array<Maybe<Videos>>>;
  groupBy?: Maybe<VideosGroupBy>;
  aggregate?: Maybe<VideosAggregator>;
};

export type VideosGroupBy = {
  __typename?: 'VideosGroupBy';
  id?: Maybe<Array<Maybe<VideosConnectionId>>>;
  created_at?: Maybe<Array<Maybe<VideosConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<VideosConnectionUpdated_At>>>;
  video?: Maybe<Array<Maybe<VideosConnectionVideo>>>;
  title?: Maybe<Array<Maybe<VideosConnectionTitle>>>;
};

export type VideosConnectionId = {
  __typename?: 'VideosConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VideosConnection>;
};

export type VideosConnectionCreated_At = {
  __typename?: 'VideosConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VideosConnection>;
};

export type VideosConnectionUpdated_At = {
  __typename?: 'VideosConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VideosConnection>;
};

export type VideosConnectionVideo = {
  __typename?: 'VideosConnectionVideo';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VideosConnection>;
};

export type VideosConnectionTitle = {
  __typename?: 'VideosConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VideosConnection>;
};

export type VideosAggregator = {
  __typename?: 'VideosAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateVideoPayload = {
  __typename?: 'createVideoPayload';
  video?: Maybe<Videos>;
};

export type UpdateVideoPayload = {
  __typename?: 'updateVideoPayload';
  video?: Maybe<Videos>;
};

export type DeleteVideoPayload = {
  __typename?: 'deleteVideoPayload';
  video?: Maybe<Videos>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  phoneNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPhoneNumber>>>;
  profilePicture?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProfilePicture>>>;
  isSubscribed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionIsSubscribed>>>;
  firstName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionFirstName>>>;
  lastName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLastName>>>;
  stripeCustomerId?: Maybe<Array<Maybe<UsersPermissionsUserConnectionStripeCustomerId>>>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionPhoneNumber = {
  __typename?: 'UsersPermissionsUserConnectionPhoneNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProfilePicture = {
  __typename?: 'UsersPermissionsUserConnectionProfilePicture';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionIsSubscribed = {
  __typename?: 'UsersPermissionsUserConnectionIsSubscribed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionFirstName = {
  __typename?: 'UsersPermissionsUserConnectionFirstName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionLastName = {
  __typename?: 'UsersPermissionsUserConnectionLastName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionStripeCustomerId = {
  __typename?: 'UsersPermissionsUserConnectionStripeCustomerId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createBookCollection?: Maybe<CreateBookCollectionPayload>;
  updateBookCollection?: Maybe<UpdateBookCollectionPayload>;
  deleteBookCollection?: Maybe<DeleteBookCollectionPayload>;
  createBook?: Maybe<CreateBookPayload>;
  updateBook?: Maybe<UpdateBookPayload>;
  deleteBook?: Maybe<DeleteBookPayload>;
  updateOnlineChurchPoster?: Maybe<UpdateOnlineChurchPosterPayload>;
  deleteOnlineChurchPoster?: Maybe<DeleteOnlineChurchPosterPayload>;
  createOnlineChurch?: Maybe<CreateOnlineChurchPayload>;
  updateOnlineChurch?: Maybe<UpdateOnlineChurchPayload>;
  deleteOnlineChurch?: Maybe<DeleteOnlineChurchPayload>;
  updatePropheticChannel?: Maybe<UpdatePropheticChannelPayload>;
  deletePropheticChannel?: Maybe<DeletePropheticChannelPayload>;
  createQuote?: Maybe<CreateQuotePayload>;
  updateQuote?: Maybe<UpdateQuotePayload>;
  deleteQuote?: Maybe<DeleteQuotePayload>;
  createSubscription?: Maybe<CreateSubscriptionPayload>;
  updateSubscription?: Maybe<UpdateSubscriptionPayload>;
  deleteSubscription?: Maybe<DeleteSubscriptionPayload>;
  createVideoCollection?: Maybe<CreateVideoCollectionPayload>;
  updateVideoCollection?: Maybe<UpdateVideoCollectionPayload>;
  deleteVideoCollection?: Maybe<DeleteVideoCollectionPayload>;
  createVideo?: Maybe<CreateVideoPayload>;
  updateVideo?: Maybe<UpdateVideoPayload>;
  deleteVideo?: Maybe<DeleteVideoPayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  cancelSubscription?: Maybe<SubscriptionPayload>;
  completeSubscription?: Maybe<SubscriptionPayload>;
  createCheckoutSession?: Maybe<CheckoutSessionPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  updateProfile?: Maybe<UsersPermissionsUser>;
  changePassword?: Maybe<ChangePasswordPayload>;
};


export type MutationCreateBookCollectionArgs = {
  input?: Maybe<CreateBookCollectionInput>;
};


export type MutationUpdateBookCollectionArgs = {
  input?: Maybe<UpdateBookCollectionInput>;
};


export type MutationDeleteBookCollectionArgs = {
  input?: Maybe<DeleteBookCollectionInput>;
};


export type MutationCreateBookArgs = {
  input?: Maybe<CreateBookInput>;
};


export type MutationUpdateBookArgs = {
  input?: Maybe<UpdateBookInput>;
};


export type MutationDeleteBookArgs = {
  input?: Maybe<DeleteBookInput>;
};


export type MutationUpdateOnlineChurchPosterArgs = {
  input?: Maybe<UpdateOnlineChurchPosterInput>;
};


export type MutationCreateOnlineChurchArgs = {
  input?: Maybe<CreateOnlineChurchInput>;
};


export type MutationUpdateOnlineChurchArgs = {
  input?: Maybe<UpdateOnlineChurchInput>;
};


export type MutationDeleteOnlineChurchArgs = {
  input?: Maybe<DeleteOnlineChurchInput>;
};


export type MutationUpdatePropheticChannelArgs = {
  input?: Maybe<UpdatePropheticChannelInput>;
};


export type MutationCreateQuoteArgs = {
  input?: Maybe<CreateQuoteInput>;
};


export type MutationUpdateQuoteArgs = {
  input?: Maybe<UpdateQuoteInput>;
};


export type MutationDeleteQuoteArgs = {
  input?: Maybe<DeleteQuoteInput>;
};


export type MutationCreateSubscriptionArgs = {
  input?: Maybe<CreateSubscriptionInput>;
};


export type MutationUpdateSubscriptionArgs = {
  input?: Maybe<UpdateSubscriptionInput>;
};


export type MutationDeleteSubscriptionArgs = {
  input?: Maybe<DeleteSubscriptionInput>;
};


export type MutationCreateVideoCollectionArgs = {
  input?: Maybe<CreateVideoCollectionInput>;
};


export type MutationUpdateVideoCollectionArgs = {
  input?: Maybe<UpdateVideoCollectionInput>;
};


export type MutationDeleteVideoCollectionArgs = {
  input?: Maybe<DeleteVideoCollectionInput>;
};


export type MutationCreateVideoArgs = {
  input?: Maybe<CreateVideoInput>;
};


export type MutationUpdateVideoArgs = {
  input?: Maybe<UpdateVideoInput>;
};


export type MutationDeleteVideoArgs = {
  input?: Maybe<DeleteVideoInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationCompleteSubscriptionArgs = {
  sessionId: Scalars['String'];
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationUpdateProfileArgs = {
  input?: Maybe<UpdateProfileInput>;
};


export type MutationChangePasswordArgs = {
  password: Scalars['String'];
};

export type CreateBookCollectionInput = {
  data?: Maybe<BookCollectionInput>;
};

export type BookCollectionInput = {
  name?: Maybe<Scalars['String']>;
  books?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UpdateBookCollectionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBookCollectionInput>;
};

export type InputId = {
  id: Scalars['ID'];
};

export type EditBookCollectionInput = {
  name?: Maybe<Scalars['String']>;
  books?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteBookCollectionInput = {
  where?: Maybe<InputId>;
};

export type CreateBookInput = {
  data?: Maybe<BookInput>;
};

export type BookInput = {
  title?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  buyNowLink?: Maybe<Scalars['String']>;
  previewLink?: Maybe<Scalars['String']>;
  bookCollections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  cover?: Maybe<Scalars['ID']>;
};

export type UpdateBookInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBookInput>;
};

export type EditBookInput = {
  title?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  buyNowLink?: Maybe<Scalars['String']>;
  previewLink?: Maybe<Scalars['String']>;
  bookCollections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  cover?: Maybe<Scalars['ID']>;
};

export type DeleteBookInput = {
  where?: Maybe<InputId>;
};

export type UpdateOnlineChurchPosterInput = {
  data?: Maybe<EditOnlineChurchPosterInput>;
};

export type EditOnlineChurchPosterInput = {
  poster?: Maybe<Scalars['ID']>;
};

export type CreateOnlineChurchInput = {
  data?: Maybe<OnlineChurchInput>;
};

export type OnlineChurchInput = {
  title?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  zoomId?: Maybe<Scalars['Long']>;
};

export type UpdateOnlineChurchInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditOnlineChurchInput>;
};

export type EditOnlineChurchInput = {
  title?: Maybe<Scalars['String']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  zoomId?: Maybe<Scalars['Long']>;
};

export type DeleteOnlineChurchInput = {
  where?: Maybe<InputId>;
};

export type UpdatePropheticChannelInput = {
  data?: Maybe<EditPropheticChannelInput>;
};

export type EditPropheticChannelInput = {
  title?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type CreateQuoteInput = {
  data?: Maybe<QuoteInput>;
};

export type QuoteInput = {
  description?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
};

export type UpdateQuoteInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditQuoteInput>;
};

export type EditQuoteInput = {
  description?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
};

export type DeleteQuoteInput = {
  where?: Maybe<InputId>;
};

export type CreateSubscriptionInput = {
  data?: Maybe<SubscriptionInput>;
};

export type SubscriptionInput = {
  stripeId?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  currentPeriodEnd?: Maybe<Scalars['Long']>;
  currentPeriodStart?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<ComponentPaymentMethodPaymentMethodInput>;
};

export type ComponentPaymentMethodPaymentMethodInput = {
  brand?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export type UpdateSubscriptionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditSubscriptionInput>;
};

export type EditSubscriptionInput = {
  stripeId?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  currentPeriodEnd?: Maybe<Scalars['Long']>;
  currentPeriodStart?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<EditComponentPaymentMethodPaymentMethodInput>;
};

export type EditComponentPaymentMethodPaymentMethodInput = {
  id?: Maybe<Scalars['ID']>;
  brand?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export type DeleteSubscriptionInput = {
  where?: Maybe<InputId>;
};

export type CreateVideoCollectionInput = {
  data?: Maybe<VideoCollectionInput>;
};

export type VideoCollectionInput = {
  name?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UpdateVideoCollectionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditVideoCollectionInput>;
};

export type EditVideoCollectionInput = {
  name?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteVideoCollectionInput = {
  where?: Maybe<InputId>;
};

export type CreateVideoInput = {
  data?: Maybe<VideoInput>;
};

export type VideoInput = {
  video?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  videoCollections?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UpdateVideoInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditVideoInput>;
};

export type EditVideoInput = {
  video?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  videoCollections?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteVideoInput = {
  where?: Maybe<InputId>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};


export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UpdateProfileInput = {
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type OnlineChurchPosterInput = {
  poster?: Maybe<Scalars['ID']>;
};

export type PropheticChannelInput = {
  title?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type BookFragment = (
  { __typename?: 'Books' }
  & Pick<Books, 'id' | 'created_at' | 'updated_at' | 'title' | 'author' | 'description' | 'buyNowLink' | 'previewLink'>
  & { cover?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )> }
);

export type PageInfoFragment = (
  { __typename?: 'PageInfo' }
  & Pick<PageInfo, 'endCursor' | 'hasNextPage'>
);

export type SubscriptionFragment = (
  { __typename?: 'SubscriptionPayload' }
  & Pick<SubscriptionPayload, 'id' | 'currentPeriodEnd' | 'currentPeriodStart' | 'name'>
  & { price?: Maybe<(
    { __typename?: 'Price' }
    & Pick<Price, 'amount' | 'currency'>
  )>, paymentMethod?: Maybe<(
    { __typename?: 'PaymentMethod' }
    & Pick<PaymentMethod, 'brand' | 'last4'>
  )> }
);

export type UploadFileFragment = (
  { __typename?: 'UploadFile' }
  & Pick<UploadFile, 'id' | 'url' | 'name' | 'created_at' | 'updated_at' | 'size' | 'mime' | 'hash' | 'provider'>
);

export type UserFragment = (
  { __typename?: 'UsersPermissionsUser' }
  & Pick<UsersPermissionsUser, 'id' | 'created_at' | 'updated_at' | 'username' | 'email' | 'provider' | 'confirmed' | 'blocked' | 'firstName' | 'lastName' | 'isSubscribed'>
  & { role?: Maybe<(
    { __typename?: 'UsersPermissionsRole' }
    & Pick<UsersPermissionsRole, 'id' | 'name' | 'description' | 'type'>
  )>, profilePicture?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )> }
);

export type VideoFragment = (
  { __typename?: 'Videos' }
  & Pick<Videos, 'id' | 'created_at' | 'updated_at' | 'title'>
  & { video?: Maybe<(
    { __typename?: 'UploadFile' }
    & UploadFileFragment
  )> }
);

export type UpdateProfileMutationVariables = Exact<{
  input?: Maybe<UpdateProfileInput>;
}>;


export type UpdateProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateProfile?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & { changePassword?: Maybe<(
    { __typename?: 'ChangePasswordPayload' }
    & Pick<ChangePasswordPayload, 'jwt'>
    & { user: (
      { __typename?: 'UsersPermissionsUser' }
      & UserFragment
    ) }
  )> }
);

export type CreateCheckoutSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCheckoutSessionMutation = (
  { __typename?: 'Mutation' }
  & { checkoutSession?: Maybe<(
    { __typename?: 'CheckoutSessionPayload' }
    & Pick<CheckoutSessionPayload, 'checkoutSessionId'>
  )> }
);

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { subscription?: Maybe<(
    { __typename?: 'SubscriptionPayload' }
    & SubscriptionFragment
  )> }
);

export type CompleteSubscriptionMutationVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type CompleteSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { completeSubscription?: Maybe<(
    { __typename?: 'SubscriptionPayload' }
    & SubscriptionFragment
  )> }
);

export type AnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalyticsQuery = (
  { __typename?: 'Query' }
  & { analytics?: Maybe<(
    { __typename?: 'Analytics' }
    & Pick<Analytics, 'accessToken' | 'sessionsToday' | 'activeUsers' | 'usersNearMe'>
  )> }
);

export type BookQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BookQuery = (
  { __typename?: 'Query' }
  & { book?: Maybe<(
    { __typename?: 'Books' }
    & BookFragment
  )> }
);

export type BookCollectionsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  where?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
}>;


export type BookCollectionsQuery = (
  { __typename?: 'Query' }
  & { bookCollections?: Maybe<Array<Maybe<(
    { __typename?: 'BookCollections' }
    & Pick<BookCollections, 'id' | 'created_at' | 'updated_at' | 'name'>
    & { books?: Maybe<Array<Maybe<(
      { __typename?: 'Books' }
      & BookFragment
    )>>> }
  )>>> }
);

export type BookCollectionQueryVariables = Exact<{
  id: Scalars['Int'];
  cursor?: Maybe<Scalars['ID']>;
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type BookCollectionQuery = (
  { __typename?: 'Query' }
  & { bookCollection?: Maybe<(
    { __typename?: 'PaginatedBookCollection' }
    & Pick<PaginatedBookCollection, 'id' | 'name'>
    & { books?: Maybe<(
      { __typename?: 'PaginatedBooks' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Books' }
        & BookFragment
      )>>>, pageInfo?: Maybe<(
        { __typename?: 'PageInfo' }
        & PageInfoFragment
      )> }
    )> }
  )> }
);

export type NextOnlineChurchQueryVariables = Exact<{ [key: string]: never; }>;


export type NextOnlineChurchQuery = (
  { __typename?: 'Query' }
  & { nextOnlineChurch?: Maybe<(
    { __typename?: 'OnlineChurch' }
    & Pick<OnlineChurch, 'id' | 'title' | 'dateTime' | 'link'>
  )> }
);

export type OnlineChurchPosterQueryVariables = Exact<{ [key: string]: never; }>;


export type OnlineChurchPosterQuery = (
  { __typename?: 'Query' }
  & { onlineChurchPoster?: Maybe<(
    { __typename?: 'OnlineChurchPoster' }
    & { poster?: Maybe<(
      { __typename?: 'UploadFile' }
      & UploadFileFragment
    )> }
  )> }
);

export type PropheticChannelQueryVariables = Exact<{ [key: string]: never; }>;


export type PropheticChannelQuery = (
  { __typename?: 'Query' }
  & { propheticChannel?: Maybe<(
    { __typename?: 'PropheticChannel' }
    & Pick<PropheticChannel, 'id' | 'title' | 'link'>
  )> }
);

export type NextQuoteQueryVariables = Exact<{
  id_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
}>;


export type NextQuoteQuery = (
  { __typename?: 'Query' }
  & { nextQuote?: Maybe<(
    { __typename?: 'Quotes' }
    & Pick<Quotes, 'id' | 'description'>
  )> }
);

export type SelfQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfQuery = (
  { __typename?: 'Query' }
  & { self?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & UserFragment
  )> }
);

export type ActiveSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveSubscriptionQuery = (
  { __typename?: 'Query' }
  & { activeSubscription?: Maybe<(
    { __typename?: 'SubscriptionPayload' }
    & SubscriptionFragment
  )> }
);

export type VideoCollectionsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  show?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
}>;


export type VideoCollectionsQuery = (
  { __typename?: 'Query' }
  & { videoCollections?: Maybe<Array<Maybe<(
    { __typename?: 'VideoCollections' }
    & Pick<VideoCollections, 'id' | 'created_at' | 'updated_at' | 'name'>
    & { videos?: Maybe<Array<Maybe<(
      { __typename?: 'Videos' }
      & VideoFragment
    )>>> }
  )>>> }
);

export type VideoCollectionQueryVariables = Exact<{
  id: Scalars['Int'];
  cursor?: Maybe<Scalars['ID']>;
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type VideoCollectionQuery = (
  { __typename?: 'Query' }
  & { videoCollection?: Maybe<(
    { __typename?: 'PaginatedVideoCollection' }
    & Pick<PaginatedVideoCollection, 'id' | 'name'>
    & { videos?: Maybe<(
      { __typename?: 'PaginatedVideos' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Videos' }
        & VideoFragment
      )>>>, pageInfo?: Maybe<(
        { __typename?: 'PageInfo' }
        & PageInfoFragment
      )> }
    )> }
  )> }
);

export type VideoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VideoQuery = (
  { __typename?: 'Query' }
  & { video?: Maybe<(
    { __typename?: 'Videos' }
    & VideoFragment
  )> }
);

export const UploadFileFragmentDoc = gql`
    fragment uploadFile on UploadFile {
  id
  url
  name
  created_at
  updated_at
  size
  mime
  hash
  url
  provider
}
    `;
export const BookFragmentDoc = gql`
    fragment book on Books {
  id
  created_at
  updated_at
  title
  author
  description
  buyNowLink
  previewLink
  cover {
    ...uploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment pageInfo on PageInfo {
  endCursor
  hasNextPage
}
    `;
export const SubscriptionFragmentDoc = gql`
    fragment subscription on SubscriptionPayload {
  id
  currentPeriodEnd
  currentPeriodStart
  name
  price {
    amount
    currency
  }
  paymentMethod {
    brand
    last4
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment user on UsersPermissionsUser {
  id
  created_at
  updated_at
  username
  email
  provider
  confirmed
  blocked
  role {
    id
    name
    description
    type
  }
  firstName
  lastName
  profilePicture {
    ...uploadFile
  }
  isSubscribed
}
    ${UploadFileFragmentDoc}`;
export const VideoFragmentDoc = gql`
    fragment video on Videos {
  id
  created_at
  updated_at
  title
  video {
    ...uploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export const UpdateProfileDocument = gql`
    mutation updateProfile($input: updateProfileInput) {
  updateProfile(input: $input) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type UpdateProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, baseOptions);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = ApolloReactCommon.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($password: String!) {
  changePassword(password: $password) {
    jwt
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type ChangePasswordMutationFn = ApolloReactCommon.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, baseOptions);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = ApolloReactCommon.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation createCheckoutSession {
  checkoutSession: createCheckoutSession {
    checkoutSessionId
  }
}
    `;
export type CreateCheckoutSessionMutationFn = ApolloReactCommon.MutationFunction<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionMutation, { data, loading, error }] = useCreateCheckoutSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, baseOptions);
      }
export type CreateCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationResult = ApolloReactCommon.MutationResult<CreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription {
  subscription: cancelSubscription {
    ...subscription
  }
}
    ${SubscriptionFragmentDoc}`;
export type CancelSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        return ApolloReactHooks.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, baseOptions);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = ApolloReactCommon.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const CompleteSubscriptionDocument = gql`
    mutation completeSubscription($sessionId: String!) {
  completeSubscription(sessionId: $sessionId) {
    ...subscription
  }
}
    ${SubscriptionFragmentDoc}`;
export type CompleteSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CompleteSubscriptionMutation, CompleteSubscriptionMutationVariables>;

/**
 * __useCompleteSubscriptionMutation__
 *
 * To run a mutation, you first call `useCompleteSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSubscriptionMutation, { data, loading, error }] = useCompleteSubscriptionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCompleteSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteSubscriptionMutation, CompleteSubscriptionMutationVariables>) {
        return ApolloReactHooks.useMutation<CompleteSubscriptionMutation, CompleteSubscriptionMutationVariables>(CompleteSubscriptionDocument, baseOptions);
      }
export type CompleteSubscriptionMutationHookResult = ReturnType<typeof useCompleteSubscriptionMutation>;
export type CompleteSubscriptionMutationResult = ApolloReactCommon.MutationResult<CompleteSubscriptionMutation>;
export type CompleteSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteSubscriptionMutation, CompleteSubscriptionMutationVariables>;
export const AnalyticsDocument = gql`
    query analytics {
  analytics {
    accessToken
    sessionsToday
    activeUsers
    usersNearMe
  }
}
    `;

/**
 * __useAnalyticsQuery__
 *
 * To run a query within a React component, call `useAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnalyticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
        return ApolloReactHooks.useQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, baseOptions);
      }
export function useAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, baseOptions);
        }
export type AnalyticsQueryHookResult = ReturnType<typeof useAnalyticsQuery>;
export type AnalyticsLazyQueryHookResult = ReturnType<typeof useAnalyticsLazyQuery>;
export type AnalyticsQueryResult = ApolloReactCommon.QueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export const BookDocument = gql`
    query book($id: ID!) {
  book(id: $id) {
    ...book
  }
}
    ${BookFragmentDoc}`;

/**
 * __useBookQuery__
 *
 * To run a query within a React component, call `useBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookQuery, BookQueryVariables>) {
        return ApolloReactHooks.useQuery<BookQuery, BookQueryVariables>(BookDocument, baseOptions);
      }
export function useBookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookQuery, BookQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookQuery, BookQueryVariables>(BookDocument, baseOptions);
        }
export type BookQueryHookResult = ReturnType<typeof useBookQuery>;
export type BookLazyQueryHookResult = ReturnType<typeof useBookLazyQuery>;
export type BookQueryResult = ApolloReactCommon.QueryResult<BookQuery, BookQueryVariables>;
export const BookCollectionsDocument = gql`
    query bookCollections($sort: String, $where: JSON, $limit: Int = 5, $start: Int) {
  bookCollections(sort: $sort, where: $where, start: $start) {
    id
    created_at
    updated_at
    name
    books(limit: $limit) {
      ...book
    }
  }
}
    ${BookFragmentDoc}`;

/**
 * __useBookCollectionsQuery__
 *
 * To run a query within a React component, call `useBookCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookCollectionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useBookCollectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookCollectionsQuery, BookCollectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<BookCollectionsQuery, BookCollectionsQueryVariables>(BookCollectionsDocument, baseOptions);
      }
export function useBookCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookCollectionsQuery, BookCollectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookCollectionsQuery, BookCollectionsQueryVariables>(BookCollectionsDocument, baseOptions);
        }
export type BookCollectionsQueryHookResult = ReturnType<typeof useBookCollectionsQuery>;
export type BookCollectionsLazyQueryHookResult = ReturnType<typeof useBookCollectionsLazyQuery>;
export type BookCollectionsQueryResult = ApolloReactCommon.QueryResult<BookCollectionsQuery, BookCollectionsQueryVariables>;
export const BookCollectionDocument = gql`
    query bookCollection($id: Int!, $cursor: ID, $sort: String, $limit: Int, $where: JSON) {
  bookCollection: paginatedBookCollection(id: $id, cursor: $cursor, sort: $sort, limit: $limit, where: $where) {
    id
    name
    books {
      nodes {
        ...book
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
}
    ${BookFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useBookCollectionQuery__
 *
 * To run a query within a React component, call `useBookCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useBookCollectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookCollectionQuery, BookCollectionQueryVariables>) {
        return ApolloReactHooks.useQuery<BookCollectionQuery, BookCollectionQueryVariables>(BookCollectionDocument, baseOptions);
      }
export function useBookCollectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookCollectionQuery, BookCollectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BookCollectionQuery, BookCollectionQueryVariables>(BookCollectionDocument, baseOptions);
        }
export type BookCollectionQueryHookResult = ReturnType<typeof useBookCollectionQuery>;
export type BookCollectionLazyQueryHookResult = ReturnType<typeof useBookCollectionLazyQuery>;
export type BookCollectionQueryResult = ApolloReactCommon.QueryResult<BookCollectionQuery, BookCollectionQueryVariables>;
export const NextOnlineChurchDocument = gql`
    query nextOnlineChurch {
  nextOnlineChurch {
    id
    title
    dateTime
    link
  }
}
    `;

/**
 * __useNextOnlineChurchQuery__
 *
 * To run a query within a React component, call `useNextOnlineChurchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextOnlineChurchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextOnlineChurchQuery({
 *   variables: {
 *   },
 * });
 */
export function useNextOnlineChurchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NextOnlineChurchQuery, NextOnlineChurchQueryVariables>) {
        return ApolloReactHooks.useQuery<NextOnlineChurchQuery, NextOnlineChurchQueryVariables>(NextOnlineChurchDocument, baseOptions);
      }
export function useNextOnlineChurchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NextOnlineChurchQuery, NextOnlineChurchQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NextOnlineChurchQuery, NextOnlineChurchQueryVariables>(NextOnlineChurchDocument, baseOptions);
        }
export type NextOnlineChurchQueryHookResult = ReturnType<typeof useNextOnlineChurchQuery>;
export type NextOnlineChurchLazyQueryHookResult = ReturnType<typeof useNextOnlineChurchLazyQuery>;
export type NextOnlineChurchQueryResult = ApolloReactCommon.QueryResult<NextOnlineChurchQuery, NextOnlineChurchQueryVariables>;
export const OnlineChurchPosterDocument = gql`
    query onlineChurchPoster {
  onlineChurchPoster {
    poster {
      ...uploadFile
    }
  }
}
    ${UploadFileFragmentDoc}`;

/**
 * __useOnlineChurchPosterQuery__
 *
 * To run a query within a React component, call `useOnlineChurchPosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnlineChurchPosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnlineChurchPosterQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnlineChurchPosterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OnlineChurchPosterQuery, OnlineChurchPosterQueryVariables>) {
        return ApolloReactHooks.useQuery<OnlineChurchPosterQuery, OnlineChurchPosterQueryVariables>(OnlineChurchPosterDocument, baseOptions);
      }
export function useOnlineChurchPosterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OnlineChurchPosterQuery, OnlineChurchPosterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OnlineChurchPosterQuery, OnlineChurchPosterQueryVariables>(OnlineChurchPosterDocument, baseOptions);
        }
export type OnlineChurchPosterQueryHookResult = ReturnType<typeof useOnlineChurchPosterQuery>;
export type OnlineChurchPosterLazyQueryHookResult = ReturnType<typeof useOnlineChurchPosterLazyQuery>;
export type OnlineChurchPosterQueryResult = ApolloReactCommon.QueryResult<OnlineChurchPosterQuery, OnlineChurchPosterQueryVariables>;
export const PropheticChannelDocument = gql`
    query propheticChannel {
  propheticChannel {
    id
    title
    link
  }
}
    `;

/**
 * __usePropheticChannelQuery__
 *
 * To run a query within a React component, call `usePropheticChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropheticChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropheticChannelQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropheticChannelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PropheticChannelQuery, PropheticChannelQueryVariables>) {
        return ApolloReactHooks.useQuery<PropheticChannelQuery, PropheticChannelQueryVariables>(PropheticChannelDocument, baseOptions);
      }
export function usePropheticChannelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PropheticChannelQuery, PropheticChannelQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PropheticChannelQuery, PropheticChannelQueryVariables>(PropheticChannelDocument, baseOptions);
        }
export type PropheticChannelQueryHookResult = ReturnType<typeof usePropheticChannelQuery>;
export type PropheticChannelLazyQueryHookResult = ReturnType<typeof usePropheticChannelLazyQuery>;
export type PropheticChannelQueryResult = ApolloReactCommon.QueryResult<PropheticChannelQuery, PropheticChannelQueryVariables>;
export const NextQuoteDocument = gql`
    query nextQuote($id_not_in: [ID]) {
  nextQuote(id_not_in: $id_not_in) {
    id
    description
  }
}
    `;

/**
 * __useNextQuoteQuery__
 *
 * To run a query within a React component, call `useNextQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextQuoteQuery({
 *   variables: {
 *      id_not_in: // value for 'id_not_in'
 *   },
 * });
 */
export function useNextQuoteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NextQuoteQuery, NextQuoteQueryVariables>) {
        return ApolloReactHooks.useQuery<NextQuoteQuery, NextQuoteQueryVariables>(NextQuoteDocument, baseOptions);
      }
export function useNextQuoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NextQuoteQuery, NextQuoteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NextQuoteQuery, NextQuoteQueryVariables>(NextQuoteDocument, baseOptions);
        }
export type NextQuoteQueryHookResult = ReturnType<typeof useNextQuoteQuery>;
export type NextQuoteLazyQueryHookResult = ReturnType<typeof useNextQuoteLazyQuery>;
export type NextQuoteQueryResult = ApolloReactCommon.QueryResult<NextQuoteQuery, NextQuoteQueryVariables>;
export const SelfDocument = gql`
    query self {
  self {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useSelfQuery__
 *
 * To run a query within a React component, call `useSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SelfQuery, SelfQueryVariables>) {
        return ApolloReactHooks.useQuery<SelfQuery, SelfQueryVariables>(SelfDocument, baseOptions);
      }
export function useSelfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelfQuery, SelfQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SelfQuery, SelfQueryVariables>(SelfDocument, baseOptions);
        }
export type SelfQueryHookResult = ReturnType<typeof useSelfQuery>;
export type SelfLazyQueryHookResult = ReturnType<typeof useSelfLazyQuery>;
export type SelfQueryResult = ApolloReactCommon.QueryResult<SelfQuery, SelfQueryVariables>;
export const ActiveSubscriptionDocument = gql`
    query activeSubscription {
  activeSubscription {
    ...subscription
  }
}
    ${SubscriptionFragmentDoc}`;

/**
 * __useActiveSubscriptionQuery__
 *
 * To run a query within a React component, call `useActiveSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveSubscriptionQuery, ActiveSubscriptionQueryVariables>) {
        return ApolloReactHooks.useQuery<ActiveSubscriptionQuery, ActiveSubscriptionQueryVariables>(ActiveSubscriptionDocument, baseOptions);
      }
export function useActiveSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveSubscriptionQuery, ActiveSubscriptionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ActiveSubscriptionQuery, ActiveSubscriptionQueryVariables>(ActiveSubscriptionDocument, baseOptions);
        }
export type ActiveSubscriptionQueryHookResult = ReturnType<typeof useActiveSubscriptionQuery>;
export type ActiveSubscriptionLazyQueryHookResult = ReturnType<typeof useActiveSubscriptionLazyQuery>;
export type ActiveSubscriptionQueryResult = ApolloReactCommon.QueryResult<ActiveSubscriptionQuery, ActiveSubscriptionQueryVariables>;
export const VideoCollectionsDocument = gql`
    query videoCollections($sort: String, $show: Int, $where: JSON, $limit: Int = 5, $start: Int) {
  videoCollections(limit: $show, sort: $sort, where: $where, start: $start) {
    id
    created_at
    updated_at
    name
    videos(limit: $limit) {
      ...video
    }
  }
}
    ${VideoFragmentDoc}`;

/**
 * __useVideoCollectionsQuery__
 *
 * To run a query within a React component, call `useVideoCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoCollectionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      show: // value for 'show'
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useVideoCollectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VideoCollectionsQuery, VideoCollectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<VideoCollectionsQuery, VideoCollectionsQueryVariables>(VideoCollectionsDocument, baseOptions);
      }
export function useVideoCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VideoCollectionsQuery, VideoCollectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VideoCollectionsQuery, VideoCollectionsQueryVariables>(VideoCollectionsDocument, baseOptions);
        }
export type VideoCollectionsQueryHookResult = ReturnType<typeof useVideoCollectionsQuery>;
export type VideoCollectionsLazyQueryHookResult = ReturnType<typeof useVideoCollectionsLazyQuery>;
export type VideoCollectionsQueryResult = ApolloReactCommon.QueryResult<VideoCollectionsQuery, VideoCollectionsQueryVariables>;
export const VideoCollectionDocument = gql`
    query videoCollection($id: Int!, $cursor: ID, $sort: String, $limit: Int, $where: JSON) {
  videoCollection: paginatedVideoCollection(id: $id, cursor: $cursor, sort: $sort, limit: $limit, where: $where) {
    id
    name
    videos {
      nodes {
        ...video
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
}
    ${VideoFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useVideoCollectionQuery__
 *
 * To run a query within a React component, call `useVideoCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVideoCollectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VideoCollectionQuery, VideoCollectionQueryVariables>) {
        return ApolloReactHooks.useQuery<VideoCollectionQuery, VideoCollectionQueryVariables>(VideoCollectionDocument, baseOptions);
      }
export function useVideoCollectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VideoCollectionQuery, VideoCollectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VideoCollectionQuery, VideoCollectionQueryVariables>(VideoCollectionDocument, baseOptions);
        }
export type VideoCollectionQueryHookResult = ReturnType<typeof useVideoCollectionQuery>;
export type VideoCollectionLazyQueryHookResult = ReturnType<typeof useVideoCollectionLazyQuery>;
export type VideoCollectionQueryResult = ApolloReactCommon.QueryResult<VideoCollectionQuery, VideoCollectionQueryVariables>;
export const VideoDocument = gql`
    query video($id: ID!) {
  video(id: $id) {
    ...video
  }
}
    ${VideoFragmentDoc}`;

/**
 * __useVideoQuery__
 *
 * To run a query within a React component, call `useVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VideoQuery, VideoQueryVariables>) {
        return ApolloReactHooks.useQuery<VideoQuery, VideoQueryVariables>(VideoDocument, baseOptions);
      }
export function useVideoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VideoQuery, VideoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VideoQuery, VideoQueryVariables>(VideoDocument, baseOptions);
        }
export type VideoQueryHookResult = ReturnType<typeof useVideoQuery>;
export type VideoLazyQueryHookResult = ReturnType<typeof useVideoLazyQuery>;
export type VideoQueryResult = ApolloReactCommon.QueryResult<VideoQuery, VideoQueryVariables>;